import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import request from '../../utils/agent';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import './UserEmployees.scss';



export default class UserEmployees extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            usersD: [],
            isEmp: false,
            companyD: {},
            compLoaded: false,
            searchEmp: "",
            deleteId : null,
            userUpdated: false,
        }
    }

    componentDidMount(){
        this.getEmployeeData();
        this.getCompanyData();
    }

    componentDidUpdate() {
        if(this.state.userUpdated === true) {
            this.getEmployeeData();
            this.getCompanyData();
            this.setState({
                userUpdated: false,
            });

        }
    }




    getEmployeeData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({usersD: resp.body.company.users});
                    this.setState({isEmp: true});
                    resolve(resp.body);
                });

        });
    };

    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true
                    });
                    resolve(resp.body);
                });

        });
    };

    deleteUser(id) {
        return new Promise((resolve, reject) => {
            request.post(`/api/deleteuser/${id}`)
                .send({
                    id: id,
                })
                .then(resp => {
                    resolve(resp.body);
                   // console.log('Call done', resp.body);
                    this.setState({
                        userUpdated: true,
                    })
                })
                .catch(err => {
                    console.error('error', err);
                })

        });
    }

    showAlert(e, row, id) {
        e.preventDefault();
        this.setState({
            deleteId: id,
        });

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui-dialog'>
                        <h3>Are you sure you want to delete this user?</h3>
                        <br/>
                        <button
                            className="btn btn-default btn-primary btn-view-users cancel"
                            onClick={onClose}>Cancel</button>
                        <button
                            className="btn btn-default btn-primary btn-view-users delete"
                            onClick={() => {
                                this.handleDeleteUser()
                                onClose()
                            }}>Confirm Delete</button>
                    </div>
                )
            }
        })
    };


    handleDeleteUser() {
        this.setState({
            isEmp: false
        });
        //console.log('handle id',this.state.deleteId);
        this.deleteUser(this.state.deleteId);
    }


    render() {
        //console.log('comp', this.state.companyD);
       // console.log('usersD', this.state.usersD);
        //console.log('deleted id', this.state.deleteId);
       // console.log('is emp', this.state.isEmp);
       // console.log('updated', this.state.userUpdated);


        let empUsers = this.state.usersD.filter(user => user.role.name === 'installer');
       // console.log('new users', empUsers);

        if(this.state.searchEmp) {
            empUsers = empUsers.filter(row => {
                return row.email.includes(this.state.searchEmp) || row.cdata.first_name.includes(this.state.searchEmp);
            })
        }




        const columns = [

            {
                Header: 'Id',
                id: 'id',
                accessor: user => user.id,
                className: 'react--tb--styles',
                show: false
            },
            {
                Header: 'Name',
                id: 'name',
                accessor: user => `${user.cdata.first_name} ${user.cdata.last_name}`,
                className: 'react--tb--styles',
            },
            {
                Header: 'Email',
                id: 'email',
                accessor: user => user.email,
                className: 'react--tb--styles',
            },
            {
                Header: 'Status',
                className: 'action--tb--styles',
                id: 'status',
                accessor: user => user.cdata.status,
                width: 60,
                Cell: row => (
                    <span
                        className='tb-status-circle'
                        style={{
                            background: row.value === 'approved'? '#39B54A':
                                row.value === 'pending' ? '#F7941E' :
                                    '#bf1e2e',
                        }}>
                  </span>
                )
            },
            {
                Header: 'View',
                width: 60,
                Cell:({row, original}) => {
                    return (
                        <Link to={`/user/employees/${original.id}`} className='view-btn-icon'>
                            <i className='ion-edit'></i>
                        </Link>
                    )
                }

            },
            {
                Header: 'Delete',
                className: 'action--tb--styles',
                width: 60,
                Cell: ({row, original}) => {
                    return (
                        <button id="delete" className='delete-btn-icon' onClick={(e) => this.showAlert(e, row, original.id)}>
                            <i className='ion-android-delete'></i>
                        </button>)
                }
            },

        ];
        const pageOpts = [10, 25, 50, 100];


        return(
            <section className='employees--container'>
                <div className="headerBtns">
                    <Link
                        to='/user/employees/new-employee'
                        id='view-all'
                        className="btn btn-default btn-primary btn-view-users view--all"> New Employee
                    </Link>
                </div>
                <h1>Your Employees</h1>
                <h4 className='emp--title'>Employees</h4>
                <div>
                    {this.state.isEmp ?

                        <div className='users-table-hoalder'>
                            <h4 className='table-title'>All Users</h4>
                            <div className='tb-search-holder'>
                                <div className='search--cont'>
                                    Search: <input
                                    className='tb-search-input'
                                    value={this.state.searchEmp}
                                    onChange={e => this.setState({searchEmp: e.target.value})}
                                />
                                </div>
                                <ReactTable
                                    columns={columns}
                                    data={empUsers}
                                    pageSizeOptions={pageOpts}
                                    pageSize={empUsers.length}

                                />
                            </div>
                        </div> :
                        <div className='emp--tb--container'>
                            <table className='employee--table'>
                                <tbody>
                                <tr className='emp--table--header'>
                                    <th className='emp-cell'>Name</th>
                                    <th className='emp-cell'>Email</th>
                                    <th className='emp-cell'>Status</th>
                                    <th className='emp-cell'></th>
                                </tr>


                                </tbody>
                            </table>
                        </div>
                    }

                </div>

            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserEmployees/index.js